// Import inhouse icons
import { ChevronsDown, ChevronsUp } from "@/components/icons_new";

export default function OrderStatTile({
  label,
  value,
  comparison = null,
  unit,
  sparkline,
  isPositive: isPositiveOverride,
  iconSizeClass = "h-3 w-3",
}) {
  const displayValue = typeof value === "number" ? value.toLocaleString("en-KE") : value;

  // Resolve trend priority: explicit override -> comparison direction -> neutral
  let trendDirection;
  if (typeof isPositiveOverride === "boolean") {
    trendDirection = isPositiveOverride ? "up" : "down";
  } else if (comparison?.direction === "up" || comparison?.direction === "down") {
    trendDirection = comparison.direction;
  } else {
    trendDirection = "neutral";
  }

  const TrendIcon =
    trendDirection === "up" ? ChevronsUp : trendDirection === "down" ? ChevronsDown : null;

  const trendColorClass =
    trendDirection === "up"
      ? "text-green-600"
      : trendDirection === "down"
        ? "text-red-600"
        : "text-gray-500";

  return (
    <div className="flex flex-row min-w-[200px] mr-[1em]">
      {/* Main info */}
      <div className="w-[60%] flex flex-col gap-[0.5em]">
        <p className="text-sm text-[#333333]">{label}</p>

        <div className="flex flex-col gap-[0.3em]">
          <span className="text-[20px] font-semibold text-[#333333]">
            {unit ? (
              <>
                <span className="text-xs font-medium text-[#868686] mr-1">{unit}</span>
                {displayValue}
              </>
            ) : (
              displayValue
            )}
          </span>

          <span className="text-xs">
            {comparison ? (
              <span className={`inline-flex items-center gap-1 ${trendColorClass}`}>
                {TrendIcon ? (
                  <TrendIcon className={iconSizeClass} />
                ) : (
                  <span
                    className={`${iconSizeClass} inline-flex items-center justify-center leading-none`}
                  >
                    -
                  </span>
                )}
                {comparison.value}%
              </span>
            ) : (
              "-"
            )}
          </span>
        </div>
      </div>

      {/* Sparkline comparison graph */}
      <div className="w-[40%] flex items-end justify-end">
        <div className="h-[40px] w-full">
          {sparkline ? (
            <div className="h-full w-full">{sparkline}</div>
          ) : (
            <div className="h-full w-[30%] rounded-full bg-blue-500 transition-all" />
          )}
        </div>
      </div>
    </div>
  );
}